/**
 * Utility functions for training components
 */

/**
 * Format duration in minutes to human-readable string
 * @param {number} minutes - Duration in minutes
 * @returns {string} Formatted duration string
 */
export const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min`;
  } else {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0 
      ? `${hours}h ${remainingMinutes}m` 
      : `${hours}h`;
  }
};

/**
 * Get status icon for training module
 * @param {Object} module - Module object with completion status
 * @returns {string} Status icon emoji
 */
export const getModuleStatusIcon = (module) => {
  if (module.is_completed) {
    return '✅';
  } else if (module.started) {
    return '🟡';
  } else {
    return '⚪';
  }
};

/**
 * Get action text for module button
 * @param {Object} module - Module object with completion status
 * @returns {string} Action button text
 */
export const getModuleActionText = (module) => {
  if (module.is_completed) {
    return 'Review';
  } else if (module.started) {
    return 'Continue';
  } else {
    return 'Start';
  }
};

/**
 * Determine if a badge is ready for automatic collection.
 * Relies entirely on backend-provided flags so frontend stays in sync.
 * @param {Object} badgeData - Badge entry from credentialing dashboard
 * @returns {boolean}
 */
export const isBadgeReadyForAutoCollection = (badgeData) => {
  if (!badgeData || !badgeData.progress) {
    return false;
  }

  const {
    is_collectable: isCollectable,
    is_collected: isCollected,
    is_earned: isEarned,
  } = badgeData.progress;

  return isCollectable === true && isCollected !== true && isEarned !== true;
};
